var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110.55 110.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-ques {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n      .class-round{\r\n        fill: #ffcf04;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "class-round",
    d: "M55.28,2.32C26.07,2.32,2.32,26.07,2.32,55.28s23.76,52.96,52.96,52.96,52.96-23.76,52.96-52.96S84.48,2.32,55.28,2.32ZM55.28,101.62c-25.55,0-46.34-20.79-46.34-46.34S29.72,8.94,55.28,8.94s46.34,20.79,46.34,46.34-20.79,46.34-46.34,46.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-ques",
    d: "M78.45,51.97h-19.86v-19.86c0-1.83-1.48-3.31-3.31-3.31s-3.31,1.48-3.31,3.31v19.86h-19.86c-1.83,0-3.31,1.48-3.31,3.31s1.48,3.31,3.31,3.31h19.86v19.86c0,1.83,1.48,3.31,3.31,3.31s3.31-1.48,3.31-3.31v-19.86h19.86c1.83,0,3.31-1.48,3.31-3.31s-1.48-3.31-3.31-3.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMas);
export default __webpack_public_path__ + "static/media/mas.695e40a35ddf59a1b89adbe17c38cb08.svg";
export { ForwardRef as ReactComponent };